module.exports = __webpack_public_path__ + "assets/img/PrizePool_btn.4b2e4376.png";